<template>
	<div>
		<p class="label" v-text="$__('profile.affiliate.title')"></p>
		<div class="affiliate-earnings">
			<h2 class="h5 h-alter" v-text="$__('profile.affiliate.request_total')"></h2>

			<div class="earnings-table">
				<div class="earnings-row">
					<div class="text" v-text="$__('profile.affiliate.purchases')"></div>
					<div class="value">{{ sales.total_purchases}}</div>
				</div>
				<div class="earnings-row">
					<div class="text" v-text="$__('profile.affiliate.earnings')"></div>
					<div class="value" v-html="formatPrice(sales.total)"></div>
				</div>
				<div class="earnings-row">
					<div class="text" v-text="$__('profile.affiliate.remaining')"></div>
					<div class="value" v-html="formatPrice(sales.total_remaining)"></div>
				</div>
				<div class="earnings-footer">
					<p v-text="$__('profile.affiliate.footer')"></p>
				</div>
			</div>
		</div>

		<div class="affiliate-earnings all-sales">
			<div class="titlebar">
				<h2 class="h5 h-alter" v-text="$__('profile.affiliate.sales')"></h2>
				<div class="links" v-html="$__('profile.affiliate.help')">
				</div>
			</div>

			<div class="earnings-table">
				<table>
					<thead>
						<tr>
							<th v-text="$__('profile.affiliate.table.order_id')"></th>
							<!-- <th>Products</th> -->
							<th v-text="$__('profile.affiliate.table.purchase_date')"></th>
							<th v-text="$__('profile.affiliate.table.code')"></th>
							<!-- <th>Discounts</th> -->
							<th v-text="$__('profile.affiliate.table.amount')"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(transaction, index) in sales.transactions" :key="index">
							<td>{{ transaction.order_id}}</td>
							<!-- <td>Products</td> -->
							<td>{{ transaction.date | formatDate }}</td>
							<td>{{ transaction.code}}</td>
							<!-- <td>discount</td> -->
							<td v-html="formatPrice(transaction.commission)"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="section-affiliate-funds withdraw">
			<div class="row align-items-md-center">
				<div class="col-md-auto text" v-if="!sales.can_withdraw && !sales.requested_payout">
					<p class="title" v-text="$__('profile.affiliate.claim_reward')"></p>
					<p v-html="$__('profile.affiliate.reward code')"></p>
				</div>

				<div class="col-md-auto text" v-if="sales.can_withdraw && !sales.requested_payout">
					<p class="title" v-text="$__('profile.affiliate.withdraw_funds')"></p>
					<p v-html="$__('profile.affiliate.reward code')"></p>
				</div>

				<div class="col-md-auto text" v-if="sales.requested_payout">
					<p class="title" v-text="$__('profile.affiliate.request_sent')"></p>
					<p v-text="$__('profile.affiliate.request_note')"></p>
				</div>

				<div class="col-md-auto ml-md-auto buttons">
					<p class="error" v-if="!sales.can_withdraw">{{ $__('profile.affiliate.under_value') }}
						<svg class="ticon"><use xlink:href="/images/icons.svg#icon-alert-triangle"></use></svg></p>
					<button :disabled="!sales.can_withdraw" v-if="!sales.requested_payout" @click="usePaypal" class="btn btn-paypal">{{ $__('profile.affiliate.send_invoice')}} <svg viewBox="0 0 90 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M33.54 4.908h-4.963a.689.689 0 00-.682.583l-2.008 12.755a.417.417 0 00.41.478h2.37a.688.688 0 00.681-.584l.541-3.44a.691.691 0 01.681-.584h1.572c3.27 0 5.156-1.585 5.65-4.727.221-1.375.009-2.455-.634-3.211-.705-.83-1.956-1.27-3.618-1.27zm.573 4.658c-.271 1.785-1.632 1.785-2.948 1.785h-.75l.526-3.333a.415.415 0 01.409-.35h.343c.896 0 1.742 0 2.179.512.26.306.34.76.24 1.386zm14.265-.057H46a.413.413 0 00-.409.35l-.105.666-.166-.242c-.515-.748-1.662-.998-2.808-.998-2.626 0-4.87 1.993-5.307 4.79-.227 1.395.096 2.729.886 3.659.724.855 1.76 1.211 2.994 1.211 2.116 0 3.29-1.363 3.29-1.363l-.106.662a.417.417 0 00.235.441.413.413 0 00.173.039h2.14a.689.689 0 00.682-.584l1.285-8.153a.415.415 0 00-.407-.478zm-3.313 4.636c-.23 1.36-1.308 2.274-2.682 2.274-.69 0-1.242-.222-1.596-.642-.352-.418-.485-1.012-.373-1.674.214-1.349 1.31-2.292 2.663-2.292.675 0 1.224.225 1.586.649.362.428.505 1.026.402 1.685zm15.972-4.636H58.65a.691.691 0 00-.571.303l-3.295 4.863-1.396-4.673a.693.693 0 00-.662-.493h-2.348a.413.413 0 00-.392.548l2.63 7.737-2.473 3.499a.415.415 0 00.338.655h2.386a.688.688 0 00.566-.297l7.945-11.491a.414.414 0 00-.34-.651z" fill="#253B80"/>
						<path d="M68.946 4.908H63.98a.689.689 0 00-.68.584l-2.008 12.754a.414.414 0 00.408.478h2.547a.482.482 0 00.477-.408l.57-3.616a.692.692 0 01.68-.584h1.57c3.271 0 5.157-1.585 5.651-4.727.223-1.374.009-2.454-.633-3.21-.705-.831-1.956-1.27-3.617-1.27zm.572 4.659c-.27 1.784-1.631 1.784-2.948 1.784h-.748l.526-3.333a.413.413 0 01.408-.35h.343c.896 0 1.742 0 2.18.512.26.306.339.76.24 1.387zm14.265-.058h-2.376a.411.411 0 00-.408.35l-.105.666-.167-.241c-.514-.749-1.661-.999-2.807-.999-2.626 0-4.87 1.994-5.306 4.79-.227 1.395.095 2.729.885 3.659.726.855 1.76 1.211 2.994 1.211 2.116 0 3.29-1.363 3.29-1.363l-.106.662a.417.417 0 00.236.442.413.413 0 00.173.038h2.14a.689.689 0 00.681-.584l1.286-8.152a.417.417 0 00-.41-.479zm-3.314 4.636c-.227 1.36-1.307 2.274-2.681 2.274-.69 0-1.242-.222-1.596-.642-.352-.418-.484-1.012-.374-1.674.216-1.349 1.31-2.292 2.664-2.292.675 0 1.224.225 1.585.649.364.428.508 1.026.402 1.685zm6.116-8.887l-2.037 12.988a.415.415 0 00.408.478h2.048c.34 0 .63-.247.681-.584l2.01-12.753a.416.416 0 00-.408-.48h-2.294a.414.414 0 00-.408.351z" fill="#179BD7"/>
						<path d="M5.274 21.203l.38-2.416-.846-.02H.77L3.576.94a.23.23 0 01.228-.195h6.808c2.26 0 3.82.47 4.634 1.401.382.436.625.892.743 1.394.123.527.125 1.156.005 1.923l-.009.056v.492l.382.217c.291.147.553.348.773.59.326.373.538.847.627 1.41.092.578.062 1.266-.09 2.045-.174.896-.455 1.676-.835 2.315a4.758 4.758 0 01-1.325 1.454 5.367 5.367 0 01-1.784.807c-.658.171-1.407.258-2.23.258h-.53c-.378 0-.746.136-1.035.382-.289.247-.48.59-.54.965l-.04.218-.67 4.258-.031.157c-.008.049-.022.074-.042.09a.112.112 0 01-.07.026H5.274z" fill="#253B80"/>
						<path d="M16.728 5.576c-.02.13-.043.263-.07.4-.897 4.62-3.969 6.215-7.892 6.215H6.77a.97.97 0 00-.959.823l-1.023 6.499-.29 1.842a.513.513 0 00.505.592h3.543c.42 0 .776-.305.842-.72l.035-.18.667-4.242.043-.232a.852.852 0 01.841-.722h.53c3.433 0 6.12-1.396 6.905-5.437.328-1.688.158-3.097-.71-4.089a3.388 3.388 0 00-.97-.749z" fill="#179BD7"/>
						<path d="M15.79 5.2a7.069 7.069 0 00-.874-.194 11.071 11.071 0 00-1.76-.128H7.818a.85.85 0 00-.841.721l-1.135 7.204-.033.21a.972.972 0 01.959-.823h1.997c3.923 0 6.995-1.596 7.893-6.214.027-.137.049-.27.07-.4a4.782 4.782 0 00-.94-.375z" fill="#222D65"/>
						<path d="M6.978 5.6a.85.85 0 01.841-.721h5.336c.632 0 1.223.041 1.761.128a7.07 7.07 0 011.075.257c.265.088.51.192.738.312.267-1.707-.002-2.87-.923-3.921C14.79.496 12.958 0 10.613 0H3.805a.974.974 0 00-.962.824L.007 18.834a.587.587 0 00.577.679h4.203l1.056-6.71L6.978 5.6z" fill="#253B80"/>
					</svg></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'Affiliate',
	props: {
		sales: Array|Object
	},
	data() {
		return {

		}
	},
	methods: {
		formatPrice (price) {
			return numbro(parseFloat(price)).formatCurrency();
		},

		usePaypal() {
			axios.get('/api/payout-request')
			.then(response => {
				console.log(response);
				if (!response.error) {
					//
				}
			})
			.catch(function (error) {
				// error
			});
		}
	},
	mounted() {

	}
}
</script>
